import { CheckIcon } from '@fukuri-admins/ui/common/Icons';
import * as CheckboxPrimitive from '@radix-ui/react-checkbox';
import * as React from 'react';
import styles from './styles.module.scss';

type Props = Omit<
  React.ComponentPropsWithoutRef<typeof CheckboxPrimitive.Root>,
  'children' | 'id' | 'value'
> & {
  /** チェックボックスのID */
  id?: string;
  /** チェックボックスの値 */
  value?: string;
  /** ラベルテキスト */
  label: string;
  /** 説明テキスト */
  description?: string;
};

const Checkbox = React.forwardRef<React.ElementRef<typeof CheckboxPrimitive.Root>, Props>(
  ({ className, id, value, label, description, ...props }, ref) => {
    const inputId = id ?? value;

    return (
      <div className={styles.checkboxWrapper}>
        <div className={styles.checkboxRow}>
          <CheckboxPrimitive.Root
            ref={ref}
            id={inputId}
            value={value}
            className={`${styles.checkboxRoot} ${className || ''}`}
            {...props}
          >
            <CheckboxPrimitive.Indicator className={styles.checkboxIndicator}>
              <CheckIcon />
            </CheckboxPrimitive.Indicator>
          </CheckboxPrimitive.Root>
          <label htmlFor={inputId} className={styles.checkboxLabel}>
            {label}
          </label>
        </div>
        {description && <span className={styles.checkboxDescription}>{description}</span>}
      </div>
    );
  }
);
Checkbox.displayName = 'Checkbox';

export type { Props as CheckboxProps };
export { Checkbox };
